import { type FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './applicationCard.css';
import {type EnvironmentClass, type ApplicationDto} from '@/models/services.ts'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { StatisticsService } from '@/services/StatisticsService';
import type { StatisticsUptimeDto } from '@/models/statisticsUptime';

type StatisticsUptimeProps = {
};

const StatisticsUptime: FC<StatisticsUptimeProps> = ({ }: StatisticsUptimeProps) => {
    
const [graphData, setGraphData] = useState<StatisticsUptimeDto[] | null>(null);
    useEffect(() => {
        if (graphData == null)
        new StatisticsService().getAll().then((data) => 
            setGraphData(data)
        );
    });

    const CustomTooltip = ({ active, payload, label, statistic }) => {
        let isVisible = active && payload && payload.length;
        return (
          <div className="tooltip-custom-style" style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
            {isVisible && (
              <>
                <p className="label">{`Time: ${payload[0].payload.date}`}</p>
                <p className="label"><span style={{ backgroundColor: '#ff3333', marginRight:"5px", width: '10px', height: '10px', display: 'inline-block' }}></span>{`Down : ${payload[0].payload.down} times (${((payload[0].payload.down / (payload[0].payload.down + payload[0].payload.up)) * 100).toFixed(2)}%)`}</p>
                <p className="label"><span style={{ backgroundColor: '#eee', marginRight:"5px", width: '10px', height: '10px', display: 'inline-block' }}></span>{`Up : ${payload[0].payload.up} times (${((payload[0].payload.up / (payload[0].payload.down + payload[0].payload.up)) * 100).toFixed(2)}%)`}</p>
              </>
            )}
          </div>
        );
      };

    return (
        graphData != null ?
            <div style={{ width: '100%', height: 150 }}>
            <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={graphData}
                margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip animationDuration={500} wrapperClassName='tooltip-custom-style'  content={CustomTooltip}  />
                <Legend wrapperStyle={{ color:"#000"}} />
                <Bar dataKey="down" stackId="a" fill="#ff3333" />
                <Bar dataKey="up" stackId="a" fill="#eee" />
            </BarChart>
            </ResponsiveContainer>
            </div> : null 
)
};

export default StatisticsUptime;

